<template>
  <b-button :class="[modalTheme, 'no-wrap']" :disabled="false" size="sm" v-b-toggle.userProfile style="height: 34px; padding-top: 3px">
    <font-awesome-icon icon="fa-solid fa-id-badge" size="lg" /> {{ user ? user.fullName : "NOT LOGGED IN" }}
  </b-button>

  <b-sidebar
    id="userProfile"
    :width="userSideBarWidth + '%'"
    ref="sideBar"
    title="USER PROFILE:"
    v-model="isUserProfileSidebarOpen"
    bg-variant="dark-blue"
    text-variant="light"
    backdrop-variant="variant"
    backdrop
    right
    shadow
  >
    <UserProfileCard />

    <UserProfileOptions />
    <div>
      <!-- {{ userSideBarWidth }} -->
      <!-- <b-row style="background: darkblue; padding: 0px">
        <b-col cols="*">123 </b-col>
      </b-row>

      <div>
        <span style="color: cyan">user {{ userStore._user.fullName }}</span>
      </div> -->
    </div>
  </b-sidebar>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import UserProfileOptions from "./UserProfileOptions.vue";

import UserProfileLogin from "./UserProfileLogin.vue";
import UserProfileCard from "./UserProfileCard.vue";

const props = defineProps({
  user: {
    Type: Object,
    Default: () => {},
  },
});
const modalTheme = computed(() => userStore.bModalTheme);

const isUserProfileSidebarOpen = ref(false);
const userSideBarWidth = ref(25);

onMounted(() => {
  // console.clear();
// console.log("onMounted() :       USER PROFILE  >>>>");
// console.log(" prop   user ");
  // console.log("props : ");
  // console.log(props);
// console.log(props.user);
});
</script>

<style scoped lang="scss">
.form {
  margin: 0 auto;
  width: 90%;
}

.btn-primary-green {
  background-color: transparent; // #26a69a;
  border-color: transparent; // #26a69a;
}

.btn-primary-green:focus,
.btn-primary-green.focus {
  //box-shadow: 1px 0px 0px 0px #b0c1b2 inset;
  color: #123486;
  background-color: transparent; // #a5dbaa;
  font-weight: bolder;
  border-color: transparent; // #26a69a;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  box-shadow: 1px 0px 0px 0px #b0c1b2 inset;
  color: #123486;
  background-color: #dcf1de;
  font-weight: bolder;
  border-color: transparent; // #26a69a;
}
.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
  border-color: transparent; // #26a69a;
}
</style>
